/**
 * Message dialogs: a card with a heading, text and a Close button, such as the contact form's
 * thank-you (Views/Contentful/Contact.cshtml). Whatever opens one calls `showModal()`; the
 * Close button is a `<form method="dialog">`, so this only adds closing from the backdrop and
 * the "Modal" analytics events, labelled by `data-event-label`.
 */

import { closeOnDismiss, trackModal } from "../shared/dialog";

export function startMessageDialog(dialog: HTMLDialogElement) {
    const label = dialog.dataset.eventLabel ?? "";
    closeOnDismiss(dialog, "[data-message-close]", (event) => event.target === dialog);
    dialog.addEventListener("close", () => trackModal("Close", label));
}

/** Opens the message dialog matching `selector`; returns whether there was one to open. */
export function openMessageDialog(selector: string): boolean {
    const dialog = document.querySelector<HTMLDialogElement>(selector);
    if (!dialog || typeof dialog.showModal !== "function") {
        return false;
    }
    dialog.showModal();
    trackModal("Open", dialog.dataset.eventLabel ?? "");
    return true;
}
